// frontend/src/main.ts
// ============================================================================
// RAVERS NETWORK - Точка входа клиентского приложения (Vue 3 + TypeScript)
// ============================================================================

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import './style.css';
// Импортируем регистратор Service Worker из сервиса пушей
import { registerServiceWorker } from '@/services/push';

// 1. Создаем экземпляр Vue приложения
const app = createApp(App);

// 2. Инициализируем хранилище Pinia
const pinia = createPinia();
app.use(pinia);

// 3. Подключаем маршрутизатор Vue Router
app.use(router);

// 4. Монтируем в корневой тег index.html
app.mount('#app');

// 5. Автоматическая регистрация Service Worker для PWA установки и Push-уведомлений
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    registerServiceWorker().catch((err) => {
      console.warn('[PWA] Service Worker registration failed:', err);
    });
  });
}
